module.exports = __webpack_public_path__ + "img/login-img.d3dff042.png";